// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as ConfirmType$OrcaPaymentPage from "./Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./Utilities/PaymentBody.bs.js";
import * as ErrorOccured$OrcaPaymentPage from "./Components/ErrorOccured.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";
import * as CommonCardProps$OrcaPaymentPage from "./Hooks/CommonCardProps.bs.js";
import * as EligibilityHelpers$OrcaPaymentPage from "./Utilities/EligibilityHelpers.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "./Context/PaymentTypeContext.bs.js";
import * as RenderPaymentMethods$OrcaPaymentPage from "./RenderPaymentMethods.bs.js";
import * as SubscriptionEventHooks$OrcaPaymentPage from "./Hooks/SubscriptionEventHooks.bs.js";

function setUserError(message) {
  Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", message);
}

function Payment(props) {
  let logger = props.logger;
  let paymentMode = props.paymentMode;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let iframeId = match$1.iframeId;
  let isManualRetryEnabled = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isManualRetryEnabled);
  let areRequiredFieldsValid = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.areRequiredFieldsValid);
  let match$2 = React.useState(() => false);
  let setIsFocus = match$2[1];
  let intent = PaymentHelpers$OrcaPaymentPage.usePaymentIntent(logger, "Card");
  let paymentType = React.useMemo(() => CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode), [paymentMode]);
  let match$3 = CommonCardProps$OrcaPaymentPage.useCardForm(logger, paymentType, paymentType !== "Card", undefined, undefined, undefined);
  let zipProps = match$3.zipProps;
  let cvcProps = match$3.cvcProps;
  let setCvcError = cvcProps.setCvcError;
  let cvcNumber = cvcProps.cvcNumber;
  let isCVCValid = cvcProps.isCVCValid;
  let expiryProps = match$3.expiryProps;
  let setExpiryError = expiryProps.setExpiryError;
  let cardExpiry = expiryProps.cardExpiry;
  let isExpiryValid = expiryProps.isExpiryValid;
  let cardProps = match$3.cardProps;
  let cardEligibilityError = cardProps.cardEligibilityError;
  let cardBrand = cardProps.cardBrand;
  let setCardError = cardProps.setCardError;
  let cardNumber = cardProps.cardNumber;
  let isCardValid = cardProps.isCardValid;
  let handleElementFocus = React.useMemo(() => (isFocus => setIsFocus(param => isFocus)), [
    isCardValid,
    isCVCValid,
    isExpiryValid,
    zipProps.isZipValid
  ]);
  React.useEffect(() => {
    if (isCardValid !== undefined && isExpiryValid !== undefined && isCVCValid !== undefined) {
      CardUtils$OrcaPaymentPage.emitIsFormReadyForSubmission(isCardValid && isExpiryValid && isCVCValid && areRequiredFieldsValid);
    }
  }, [
    isCardValid,
    isExpiryValid,
    isCVCValid,
    areRequiredFieldsValid
  ]);
  React.useEffect(() => {
    let handleDoSubmit = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let jsonDict = Utils$OrcaPaymentPage.getDictFromJson(json);
      let confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(jsonDict);
      if (confirm.doSubmit) {
        let confirmParam = confirm.confirmParams;
        let match = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
        let validFormat;
        switch (match) {
          case "Card" :
            validFormat = Core__Option.getOr(isCardValid, false) && Core__Option.getOr(isExpiryValid, false) && Core__Option.getOr(isCVCValid, false) && Core__Option.isNone(cardEligibilityError);
            break;
          case "CardNumberElement" :
            validFormat = Core__Option.getOr(isCardValid, false) && CardUtils$OrcaPaymentPage.checkCardCVC(CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-cvc"), cardBrand) && CardUtils$OrcaPaymentPage.checkCardExpiry(CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-expiry")) && Core__Option.isNone(cardEligibilityError);
            break;
          default:
            validFormat = true;
        }
        let cardNetwork = [[
            "card_network",
            cardBrand !== "" ? cardBrand : null
          ]];
        if (validFormat) {
          let match$1 = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
          let body;
          switch (match$1) {
            case "Card" :
              let match$2 = CardUtils$OrcaPaymentPage.getExpiryDates(cardExpiry);
              body = PaymentBody$OrcaPaymentPage.cardPaymentBody(cardNumber, match$2[0], match$2[1], Primitive_option.some(undefined), cvcNumber, cardNetwork, undefined);
              break;
            case "CardNumberElement" :
              let match$3 = CardUtils$OrcaPaymentPage.getExpiryDates(CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-expiry"));
              let localCvcNumber = CardUtils$OrcaPaymentPage.getCardElementValue(iframeId, "card-cvc");
              body = PaymentBody$OrcaPaymentPage.cardPaymentBody(cardNumber, match$3[0], match$3[1], Primitive_option.some(undefined), localCvcNumber, cardNetwork, undefined);
              break;
            default:
              body = [];
          }
          let match$4 = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
          switch (match$4) {
            case "Card" :
            case "CardNumberElement" :
              return intent(false, body, confirmParam, undefined, undefined, undefined, isManualRetryEnabled, undefined);
            default:
              return;
          }
        } else {
          if (cardNumber === "") {
            setCardError(param => localeString.cardNumberEmptyText);
            Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
          } else if (Core__Option.isSome(cardEligibilityError)) {
            let msg = EligibilityHelpers$OrcaPaymentPage.getCardEligibilityErrorText(cardEligibilityError, localeString);
            setCardError(param => msg);
            Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", msg);
          }
          if (cardExpiry === "") {
            setExpiryError(param => localeString.cardExpiryDateEmptyText);
            Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
          }
          if (cvcNumber === "") {
            setCvcError(param => localeString.cvcNumberEmptyText);
            Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
          }
          if (!validFormat) {
            return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterValidDetailsText);
          } else {
            return;
          }
        }
      }
    };
    return Utils$OrcaPaymentPage.handleMessage(handleDoSubmit, "");
  }, [
    cardNumber,
    cvcNumber,
    cardExpiry,
    isCVCValid,
    isExpiryValid,
    isCardValid,
    cardEligibilityError,
    match$1.sdkAuthorization
  ]);
  React.useEffect(() => {
    let mode = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
    switch (mode) {
      case "Card" :
      case "CardNumberElement" :
      case "CardExpiryElement" :
        SubscriptionEventHooks$OrcaPaymentPage.emitReady(iframeId, CardThemeType$OrcaPaymentPage.getPaymentModeToString(mode));
        break;
    }
  }, [
    iframeId,
    paymentMode
  ]);
  if (props.integrateError) {
    return JsxRuntime.jsx(ErrorOccured$OrcaPaymentPage.make, {});
  } else {
    return JsxRuntime.jsx(PaymentTypeContext$OrcaPaymentPage.provider, {
      value: {
        paymentType: paymentType
      },
      children: JsxRuntime.jsx(RenderPaymentMethods$OrcaPaymentPage.make, {
        paymentType: paymentType,
        cardProps: cardProps,
        expiryProps: expiryProps,
        cvcProps: cvcProps,
        zipProps: zipProps,
        handleElementFocus: handleElementFocus,
        blurState: match$3.blurState,
        isFocus: match$2[0]
      })
    });
  }
}

let make = Payment;

export {
  setUserError,
  make,
}
/* jotai Not a pure module */
